import React, { useEffect, useState, MouseEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';

import '../scss/vip-service.scss';
import Color from '@/tool/color';

interface IProps {}
interface IState {}

const VipService = (props: IProps, state: IState) => {
  const location = useLocation();
  const navi = useNavigate();

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="vip-service">
      <section className="service-container">
        <p className="box1"></p>
        <p className="box2"></p>
        <p className="box3"></p>
        <p className="box4"></p>
        <section className="section-01">
          <b>普通用户</b>
          <span className="one-31">市场职位数据有限，无法查看细分行业职位薪酬数据</span>
          <span className="one-31">HR行业核心指标只能查看虚拟数据</span>
          <span className="one-31">单次最多只能查看5个市场职位数据，耗时耗力</span>
          <span className="one-31">无法对标特定企业薪酬数据，无法使用薪酬体系工具</span>
          <span className="one-31">......</span>
        </section>
        <section className="section-02">
          <b>企业套餐用户</b>
          <p className="line-05">
            <span className="span-06">可以查看平台全部</span>
            <span className="span-05">100+细分行业</span>
            <span className="span-06">，</span>
            <span className="span-05">3000+市场职位</span>
            <span className="span-06">数据</span>
          </p>
          <p className="line-05">
            <span className="span-05">50+HR行业核心指标</span>
            <span>，市场真实数据</span>
          </p>
          <p className="line-05">
            <span className="span-06">单次最多可查询</span>
            <span className="span-05">50个市场职位数据</span>
            <span>，满足企业日常招聘职位需求</span>
          </p>
          <p className="line-05">
            <span className="span-05">指定对标企业</span>
            <span>，获得对标企业真实薪酬水平，调整自己公司薪酬水平竞争力</span>
          </p>
          <p className="line-05">
            <span className="span-05">公司薪酬分析</span>
            <span className="span-06">、</span>
            <span className="span-05">薪酬体系设计</span>
            <span className="span-06">平台更多工具全部解锁</span>
          </p>
          <p className="line-05">
            <span className="span-06 span-07">......</span>
          </p>
        </section>
      </section>
    </section>
  );
};

export default observer(VipService);
